export default __webpack_public_path__ + "static/media/slider3.eb2837ad.jpg";